/**
 * Blip AI Service Layer
 * Target: https://mantra-backend-app.azurewebsites.net/api/blipai/stt/transcribe
 */
export const blipService = {
  getToken() {
    return localStorage.getItem('blip_token') || import.meta.env.VITE_BLIP_TOKEN;
  },

  getUrl() {
    return import.meta.env.VITE_BLIP_URL || "https://mantra-backend-app.azurewebsites.net/api/blipai/stt/transcribe";
  },

  async testConnection() {
    const token = this.getToken();
    const url = this.getUrl();
    
    if (!token) return { success: false, message: 'No token found.' };

    try {
      // Check if the server responds or blocks via CORS
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ test: true })
      });

      if (response.status === 405 || response.ok || response.status === 400) {
        return { success: true, message: 'Server reached! CORS is configured.' };
      }
      return { success: false, message: `Server returned status: ${response.status}` };
    } catch (error) {
      if (error.message === 'Failed to fetch') {
        return { 
          success: false, 
          message: 'CORS Error. Ensure the backend allows requests from this domain.' 
        };
      }
      return { success: false, message: error.message };
    }
  },

  async transcribe(audioBlob) {
    const token = this.getToken();
    const url = this.getUrl();

    if (!token || token === 'your_bearer_token_here') {
      throw new Error('Please go to Settings and enter a valid Blip AI Token.');
    }

    // Prepare exactly as per the provided script
    const audioFile = new File([audioBlob], "recording.wav", { type: "audio/wav" });
    const formData = new FormData();
    formData.append("audio", audioFile);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { 
          "Authorization": `Bearer ${token}` 
        },
        body: formData
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API Error (${response.status}): ${errorText || 'Transcription failed'}`);
      }

      const data = await response.json();
      // The API returns 'text' as per the script provided
      return data.text || data.transcript || '';
    } catch (error) {
      if (error.message === 'Failed to fetch') {
        throw new Error('Network error: Likely a CORS restriction in Azure.');
      }
      throw error;
    }
  }
};

export default blipService;